import { Suspense, lazy } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Lazy-loaded components with webpackChunkName "vendor-portal-app"
export const VendorLayout = Loader(
  lazy(() => import(/* webpackChunkName: "vendor-portal-app" */ './VendorLayout'))
);

export const VendorLoginPage = Loader(
  lazy(() => import(/* webpackChunkName: "vendor-portal-app" */ './Auth/VendorLoginPage'))
);

export const VendorDashboard = Loader(
  lazy(() => import(/* webpackChunkName: "vendor-portal-app" */ './Dashboard/VendorDashboard'))
);

export const AssignedJobsList = Loader(
  lazy(() => import(/* webpackChunkName: "vendor-portal-app" */ './Jobs/AssignedJobsList'))
);

export const SubmitCandidate = Loader(
  lazy(() => import(/* webpackChunkName: "vendor-portal-app" */ './Candidates/SubmitCandidate'))
);

export const MyCandidatesList = Loader(
  lazy(() => import(/* webpackChunkName: "vendor-portal-app" */ './Candidates/MyCandidatesList'))
);

// Route configuration — mirrors onboardingRoutes shape
const vendorRoutes = {
  path: 'vendor',
  children: [
    {
      // Login page (no layout wrapper — uses parent BaseLayout)
      path: 'login',
      element: <VendorLoginPage />
    },
    {
      // All authenticated vendor portal routes wrapped in VendorLayout
      path: '',
      element: <VendorLayout />,
      children: [
        { path: '', element: <VendorDashboard /> },
        { path: 'dashboard', element: <VendorDashboard /> },
        { path: 'jobs', element: <AssignedJobsList /> },
        { path: 'candidates', element: <MyCandidatesList /> },
        { path: 'candidates/new', element: <SubmitCandidate /> }
      ]
    }
  ]
};

export default vendorRoutes;
